// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.ce.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	apiConfig: {
		// apiUrl: 'https://api.dev.platform.axso.co',
		apiUrl: 'https://hypercharge-api.dev.axso.io',
		authPath: 'customer',
		// domain: 'api.dev.platform.axso.co',
		domain: 'hypercharge-api.dev.axso.io',
		basic: {
			key: 'rVKkRgwzKbY7CJhSPaSwrqynDk3Uu8Kb',
			secret: 'pGxbg2Qf7YFAXP2RtCHTXVq4fpXheCg2',
		},
	},
	webclientTripPlannerUrl: '',
	stripe: {
		usd: {
			key: 'pk_test_51KTDJbEuXxlIxpa3r8lS4HLd4qroPxDdta7hDyVwUkGGZUPTuMLxB3WHxeDXdlzhg6eh7hCyksxXhpnL4hcAykhA00S2YiRUpV',
		},
		cad: {
			key: 'pk_test_51KTDJbEuXxlIxpa3r8lS4HLd4qroPxDdta7hDyVwUkGGZUPTuMLxB3WHxeDXdlzhg6eh7hCyksxXhpnL4hcAykhA00S2YiRUpV',
		},
	},
	mapBox: {
		accessToken: 'pk.eyJ1IjoiZ2JlZ2luIiwiYSI6ImNremZxbWs5NTAwYmwybm8ybHlzYnExOW0ifQ.GPBFuZubaDBxgQgJjydbUA',
		mapUrl: '',
	},
	htmlEditorKey: '',
	facebookAppId: '653107652604265',
	googleClientId: '916187979633-jek02sfiup2jnth8h1r2dqpk8btd9k6k.apps.googleusercontent.com',
	apple: {
		clientId: 'com.hypercharge.app.signin',
		redirectURI: 'https://hypercharge-api.dev.axso/v1/customer/signin/apple/redirect',
	},
	production: false,
	siteUrl: 'https://hypercharge-api.dev.axso',
	siteTitle: 'Hypercharge',
	version: '2.9.0',
	appLink: 'https://hypercharge.test-app.link',
	google: {
		apiKey: 'AIzaSyBmO9T_1RjYgMiUyNw2693gtx6da53WiEg',
		map: {
			initialPosition: {
				lat: 45.4972159,
				lng: -73.6103642,
			},
		},
		measurementId: null,
		tagManagerId: null,
		reCaptcha: {
			siteKey: '',
		},
	},
	defaultCurrency: {
		code: 'CAD',
		digits: 2.0,
		symbol: '$',
	},
	mainNetwork: {
		id: '5cdd70eea2979e7e90c03562',
		name: {
			fr: 'Hypercharge',
			en: 'Hypercharge',
		},
		fullName: {
			fr: 'Hypercharge - Va plus loin en toute confiance.',
			en: 'Hypercharge - Go Further With Confidence.',
		},
		abbreviation: {
			fr: 'Hypercharge',
			en: 'Hypercharge',
		},
		brand: null,
	},
	menuItems: [
		{
			path: 'faq',
			labelKey: 'FAQ.NAVIGATION-LABEL',
			submenu: [],
			externalUrl: {
				en: 'https://hypercharge.com/about/',
				fr: 'https://hypercharge.com/about/',
			},
		},
		{
			path: 'dashboard',
			labelKey: 'DASHBOARD.NAVIGATION-LABEL',
			icon: 'dashboard',
			submenu: [],
		},
		// {
		// 	path: 'tripPlanner',
		//	labelKey: 'TRIP-PLANNER.NAVIGATION-LABEL',
		//	icon: 'airline_stops',
		//	submenu: [],
		// },
		{
			path: 'wallet',
			labelKey: 'WALLET.NAVIGATION-LABEL',
			icon: 'account_balance_wallet',
			submenu: [],
		},
		{
			path: '/vehicles',
			labelKey: 'VEHICLE.NAVIGATION-LABEL',
			icon: 'directions_car',
			submenu: [],
		},
		{
			path: 'transactions',
			labelKey: 'TRANSACTION.NAVIGATION-LABEL',
			icon: 'receipt',
			submenu: [],
		},
		{
			path: 'sessions',
			labelKey: 'SESSION.NAVIGATION-LABEL',
			icon: 'update',
			submenu: [],
		},
		// {
		//    path: '/memberCards',
		//    labelKey: 'MEMBER-CARD.NAVIGATION-LABEL',
		//    icon: 'credit_card',
		//    submenu: [],
		// },
		// {
		//    path: '/inbox',
		//    labelKey: 'INBOX.NAVIGATION-LABEL',
		//    icon: 'inbox',
		//    submenu: [],
		// },
		{
			path: 'settings',
			labelKey: 'SETTING.NAVIGATION-LABEL',
			icon: 'settings',
			submenu: [],
		},
	],
	footerMenuItems: [
		{
			path: 'contact-us',
			labelKey: 'CONTACT-US.NAVIGATION-LABEL',
			submenu: [],
			externalUrl: {
				en: 'https://hypercharge.com/contact/',
				fr: 'https://hypercharge.com/contact/',
			},
		},
		{
			path: 'about',
			labelKey: 'ABOUT.NAVIGATION-LABEL',
			submenu: [],
			externalUrl: {
				en: 'https://hypercharge.com/about-us/',
				fr: 'https://hypercharge.com/about-us/',
			},
		},
		{
			path: 'auth/terms-of-use',
			labelKey: 'TERMS-OF-USE.NAVIGATION-LABEL',
			submenu: [],
			externalUrl: {
				en: 'https://hypercharge.com/terms/',
				fr: 'https://hypercharge.com/terms/',
			},
		},
	],
	firebase: {
		apiKey: 'AIzaSyBmO9T_1RjYgMiUyNw2693gtx6da53WiEg',
		authDomain: 'hyper-charge---dev.firebaseapp.com',
		projectId: 'hyper-charge---dev',
		storageBucket: 'hyper-charge---dev.appspot.com',
		messagingSenderId: '916187979633',
		appId: '1:916187979633:web:597a06b6d08be00f5a60d0',
		measurementId: 'G-GB1NXE1NZ8',
	},
	FF_CONFIG_ENABLED: true,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error'; // Included with Angular CLI.
